import React from 'react';
import PropTypes from 'prop-types';
import StyledFormField from './styles';
export default function FormField({
  className,
  children
}) {
  return /*#__PURE__*/React.createElement(StyledFormField, {
    className
  }, children);
}
FormField.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=index.js.map